import { mergeMap, catchError } from 'rxjs/operators';
import { ofType } from 'redux-observable';
import { EMPTY, from } from 'rxjs';

import Global from '../../store/global-selectors';
import * as Actions from './alerts.actions';
import * as OrderAlertsApi from '../../store/order-alerts/order-alerts.api';
import { PAGE_SIZE_50 } from '../../services/pagination-service';

const assignSalesOrderIdFromEntities = (getState, alerts) => {
  const state = getState();
  return alerts
    .filter((alert) => !!alert.orderID)
    .map((alert) => {
      const salesOrderIds = Global.selectEntitiesSalesOrderIdsByFulfillmentPlanIds(state, {
        fulfillmentPlanIds: [alert.orderID],
      });
      return {
        ...alert,
        salesOrderID: salesOrderIds[0],
      };
    });
};

export const getMoreOrderAlertsEpic = (action$, { getState }) => {
  return action$.pipe(
    ofType(Actions.GET_MORE_ORDER_ALERTS),
    mergeMap((action) => {
      const { page, successResponse, failureResponse } = action;
      return from(OrderAlertsApi.getOrderAlerts(page, PAGE_SIZE_50)).pipe(
        mergeMap((response) => {
          const alerts = assignSalesOrderIdFromEntities(getState, response);
          assignSalesOrderIdFromEntities(getState, alerts);
          successResponse(alerts);
          return EMPTY;
        }),
        catchError(() => {
          failureResponse();
          return EMPTY;
        }),
      );
    }),
  );
};
